import * as React from 'react';
import PersistentIframeController from 'src/components/persistent-iframe/persistent-iframe-controller';
import { IframeApps } from 'src/components/persistent-iframe/persistent-iframe.constants';
import { useLocation } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import Navbar from 'src/common/Navbar/Navbar';

const ANALYTICS_BASE_PATH = '/analytics';

const Analytics = () => {
  const location = useLocation();
  const route = location.pathname.substring(ANALYTICS_BASE_PATH.length);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <DocumentTitle title="Analytics" />
      <Navbar title="Analytics" />
      <PersistentIframeController route={route} appName={IframeApps.Analytics} />
    </div>
  );
};

export default Analytics;
